import {
    splitLeadingBlockquoteQuote,
    splitQuotedHtml,
    splitTrailingBlockquoteQuote,
} from './collapseQuotedHtml';

/**
 * Join out-of-band quote + body for send in top-post order:
 * fresh reply first, cited history after (matches the composer UI).
 */
export function composeReplyMessage(bodyHtml: string, quoteHtml: string): string {
    return `${bodyHtml || ''}${quoteHtml || ''}`;
}

function isUsableSplit(split: { visibleHtml: string; quotedHtml: string } | null): split is {
    visibleHtml: string;
    quotedHtml: string;
} {
    return !!(split?.visibleHtml?.trim() && split?.quotedHtml?.trim());
}

/**
 * Peel a composer citation out of a merged draft so Draft only holds the body.
 * Accepts both legacy leading-quote drafts and top-post trailing quotes.
 * Returns null when no citation blockquote is present.
 */
export function peelLeadingReplyQuote(html: string): { bodyHtml: string; quoteHtml: string } | null {
    const leading = splitLeadingBlockquoteQuote(html || '');
    if (isUsableSplit(leading))
        return { bodyHtml: leading.visibleHtml, quoteHtml: leading.quotedHtml };

    const trailing = splitTrailingBlockquoteQuote(html || '');
    if (isUsableSplit(trailing))
        return { bodyHtml: trailing.visibleHtml, quoteHtml: trailing.quotedHtml };

    return null;
}

/**
 * Fresh (non-quoted) HTML to cite when replying from the timeline.
 * Avoids re-including nested history that would reorder as
 * [new reply][oldest][middle] under top-post.
 */
export function visibleMessageHtmlForQuote(html: string, previousHtmls: string[] = []): string {
    const split = splitQuotedHtml(html || '', previousHtmls);
    if (isUsableSplit(split))
        return split.visibleHtml;
    return html || '';
}
